import includes from 'lodash/includes';

import { LANGUAGE_ZH } from '../constants';

/**
 * Function that formats locale or truncates 1 part of language abbreviation.
 * @example en-GB -> en, zh-CN -> zh-hans
 */

export default function formatLocale(locale) {
  if (includes(locale, 'zh')) {
    return LANGUAGE_ZH;
  }

  return locale.indexOf('-') === -1 ? locale : locale.substring(0, locale.indexOf('-'));
}
